/**
 * Tuning numbers for the inline diff. They decide when the word-by-word diff gives up and shows
 * one delete plus one insert instead - the two ways an element can be "too different to align".
 */

/** Above this many characters on either side, aligning character by character costs more than it is worth. */
export const MAX_CHAR_DIFF = 2000;

/** Under four words, low shared-word coverage says nothing - a two-word title may share no words with its replacement. */
export const MIN_GATED_WORDS = 4;

/**
 * Measured on real rewrites: two unrelated paragraphs share 5-12% of their words, a rewrite that
 * keeps the meaning 24%, a heavy rewrite that keeps the wording 50%. Nothing landed between 24 and
 * 50, so this sits in an empty gap.
 */
export const MIN_SHARED_WORD_RATIO = 0.35;
